import { useSearchParams } from 'react-router-dom';
import {
  EMBED_WORKFLOW_SRC_PARAM,
  getTrustedIframeUrl,
} from '../utils/embedWorkflow';

/**
 * Whether the host page should hand its content over to `EmbeddedWorkflowView`.
 *
 * Every host page asks `?src=` the same question, and the answer has to stay
 * "does this resolve to a trusted URL" rather than "is the param present":
 * an untrusted value must leave the page rendering its own content, not an
 * empty embed. Shared so that check cannot drift between pages.
 */
export const useEmbeddedWorkflowActive = () => {
  const [searchParams] = useSearchParams();

  return Boolean(
    getTrustedIframeUrl(searchParams.get(EMBED_WORKFLOW_SRC_PARAM)),
  );
};
